// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1vGTR","productName":"Table_productName__1rIWB"};